export const USER_ACTION_TYPE = {
  LIST: 'LIST',
  COLLAPSABLE: 'COLLAPSABLE',
  POPUP: 'POPUP'
};